import { render, staticRenderFns } from "./CoownersForm.vue?vue&type=template&id=27a53ddc&scoped=true&"
import script from "./CoownersForm.vue?vue&type=script&lang=js&"
export * from "./CoownersForm.vue?vue&type=script&lang=js&"
import style0 from "./CoownersForm.vue?vue&type=style&index=0&id=27a53ddc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a53ddc",
  null
  
)

export default component.exports